"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Messenger = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Messenger = function Messenger(_a) {
  var id = _a.id;
  var clipPathId = id ? "Messenger__clip0__".concat(id) : 'Messenger__clip0';
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("g", {
    clipPath: "url(#".concat(clipPathId, ")")
  }, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 11.398C.17 4.94 5.537-.157 11.994.004 18.45-.157 23.817 4.94 23.987 11.398c-.17 6.456-5.537 11.555-11.993 11.394-.925 0-1.846-.105-2.747-.312a1.199 1.199 0 00-.732.06l-3.25 1.367a1.2 1.2 0 01-1.127-.108 1.2 1.2 0 01-.54-1.007v-2.759a1.2 1.2 0 00-.348-.84A11.058 11.058 0 010 11.399zm15.448 2.05l3.142-4.797a.516.516 0 00-.12-.743.516.516 0 00-.671 0l-3.67 2.806-2.759-2.11a1.775 1.775 0 00-1.091-.36h-.252a1.811 1.811 0 00-1.512.803l-3.154 4.761a.6.6 0 00.084.756.516.516 0 00.672 0l3.598-2.699 2.627 2.027c.312.242.696.372 1.09.372h.517c.605 0 1.17-.307 1.499-.815z",
    clipRule: "evenodd"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("clipPath", {
    id: clipPathId
  }, react_1.default.createElement("path", {
    fill: "#fff",
    d: "M0 0H24V24H0z"
  }))));
};

exports.Messenger = Messenger;